import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Alliance from './views/Alliance.vue'
import RescueAlliance from './views/RescueAlliance.vue'
import Results from './views/Results.vue'
import ArticleDetails from './components/articleDetails.vue'
import Yinsshengming from './components/yinsishengming.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/alliance',
    name: 'Alliance',
    component: Alliance
  },
  {
    path: '/rescue-alliance',
    name: 'RescueAlliance',
    component: RescueAlliance
  },
  {
    path: '/results',
    name: 'Results',
    component: Results
  },
  {
    path:'/articleDetails',
    name:'ArticleDetails',
    component: ArticleDetails
  },
  {
    path:'/yinsishengming',
    name:'Yinsshengming',
    component: Yinsshengming
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router 